// extracted by mini-css-extract-plugin
module.exports = {"root":"Autocomplete_root__3w-J-","rootDisabled":"Autocomplete_rootDisabled__1cCW0"};